var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{staticClass:"mb-32",attrs:{"cols":"12"}},[_c('page-content',{attrs:{"breadcrumbTitle":true,"breadcrumb":[
        {
          title: 'Components',
          link: '/components/components-page',
        },
        {
          title: 'Data Display',
        },
      ]},scopedSlots:_vm._u([{key:"desc",fn:function(){return [_c('p',{staticClass:"h5 mb-0 mt-24 hp-text-color-black-0"},[_vm._v(" Small and adaptive tag for adding context to just about any content. ")])]},proxy:true}])})],1),_c('b-col',{staticClass:"mb-32",attrs:{"cols":"12"}},[_c('basic')],1),_c('b-col',{staticClass:"mb-32",attrs:{"cols":"12"}},[_c('buttons')],1),_c('b-col',{staticClass:"mb-32",attrs:{"cols":"12"}},[_c('contextual-variations')],1),_c('b-col',{staticClass:"mb-32",attrs:{"cols":"12"}},[_c('pill')],1),_c('b-col',{staticClass:"mb-32",attrs:{"cols":"12"}},[_c('actionable')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }